import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {PostbackLog} from '../../models/postback/postback-log';

@Injectable({
  providedIn: 'root'
})
export class PostbackLogService extends AbstractModelService<PostbackLog> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/postback-log', PostbackLog);
  }
}
